import React from 'react'
import { Notification, Box, Link, Text, ThemeProvider } from '@deseretbook/react-ui'

/**
 * Displays a notice to the user that we use cookies. We only show this notice once.
 *
 * @returns {function} Component
 */
const CookieNotice = () => {
  let userHasSeenNotice = false

  try {
    userHasSeenNotice = Boolean(window.localStorage.getItem('dbcom:cookieNotice'))
  } catch (error) {
    // oh well...
  }

  React.useEffect(() => {
    if (userHasSeenNotice) {
      return
    }

    try {
      window.localStorage.setItem('dbcom:cookieNotice', String(new Date()))
    } catch (error) {
      // oh well...
    }
  }, [])

  if (userHasSeenNotice) {
    return false
  }

  return (
    <ThemeProvider>
      <Box padding={1} isFullwidth style={{ position: 'fixed', bottom: 0, left: 0, zIndex: 10000000000 }}>
        <Notification titleContent="We use cookies">
          We use cookies to give you the best possible experience. <Link href="/privacy" size="tiny" aria-label="Click here to learn more about our privacy policy"><Text size="small" color="primary">Learn more.</Text></Link>
        </Notification>
      </Box>
    </ThemeProvider>
  )
}

// react-rails wants the component to be the primary export.
/* eslint-disable-next-line import/no-default-export */
export default CookieNotice
